/**
 * Helper: Auth-geschuetzte Datei (PDF, Bild) im neuen Tab oeffnen ODER herunterladen.
 *
 * Mobile-Fallstricke:
 *  - iOS Safari blockiert blob: URLs, die per `window.open('')` + spaeterem
 *    `location.href = blobUrl` gesetzt werden.
 *  - Android Chrome 14x: synthetischer <a>-Click ohne user-gesture-chain kann
 *    das Tab-Oeffnen blockieren, oder die blob-URL wird in einer fremden App
 *    geoeffnet (Files / Drive) und Chrome zeigt nichts an.
 *  - Lange JWT in `?token=` koennen abgeschnitten werden.
 *  - Ohne `Content-Disposition: inline` wird die Datei statt angezeigt
 *    heruntergeladen (Backend setzt das aber schon).
 *
 *  Strategie: fetch -> blob -> <a>-Click. Wenn `forceDownload` true ist, wird
 *  download-Attribut gesetzt (nativer Download).
 *
 * @param {string} relativeUrl  z.B. "/api/uploads/abc.pdf"
 * @param {object} [opts]
 * @param {string} [opts.filename]       Dateiname fuer Download
 * @param {boolean} [opts.forceDownload] true = nativer Download statt Anzeige
 */
export async function openAuthFile(relativeUrl, opts = {}) {
  if (!relativeUrl) return;
  const { filename, forceDownload = false } = opts;

  const fullUrl = /^https?:\/\//i.test(relativeUrl)
    ? relativeUrl
    : `${process.env.REACT_APP_BACKEND_URL}${relativeUrl}`;

  const token = localStorage.getItem('token') || sessionStorage.getItem('token');

  let response;
  try {
    response = await fetch(fullUrl, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  } catch (e) {
    throw new Error(`Netzwerkfehler beim Laden: ${e.message || e}`);
  }

  if (!response.ok) {
    throw new Error(`Server-Fehler ${response.status} ${response.statusText}`);
  }

  let blob;
  try {
    blob = await response.blob();
  } catch (e) {
    throw new Error(`Datei konnte nicht gelesen werden: ${e.message || e}`);
  }

  const blobUrl = URL.createObjectURL(blob);

  // Synthetischer Click - funktioniert auf iOS Safari, Android Chrome, Desktop.
  const a = document.createElement('a');
  a.href = blobUrl;
  if (forceDownload) {
    a.setAttribute('download', filename || 'download');
  } else {
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
  }
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    a.remove();
    URL.revokeObjectURL(blobUrl);
  }, 60_000);
}
